// src/features/treasury/components/TreasuryDashboard/TreasuryStats.jsx
import React from 'react';
import StatCard from '../../../../shared/components/ui/StatCard';
import styles from './TreasuryDashboard.module.css';

const TreasuryStats = ({ treasury }) => {
  if (!treasury) return null;
  return (
    <div className={styles.statsGrid}>
      <StatCard title="الرصيد الحالي" value={treasury.current_balance} unit="د.ع" color="info" icon="💰" decimals={0} />
      <StatCard title="الرصيد الافتتاحي" value={treasury.opening_balance} unit="د.ع" color="default" icon="🏦" decimals={0} />
      <StatCard title="إجمالي الوارد (اليوم)" value={treasury.total_inflow_today} unit="د.ع" color="success" icon="📥" decimals={0} />
      <StatCard title="إجمالي الصادر (اليوم)" value={treasury.total_outflow_today} unit="د.ع" color="danger" icon="📤" decimals={0} />
      <StatCard title="صافي اليوم" value={treasury.net_today} unit="د.ع" color={treasury.net_today >= 0 ? "profit" : "expense"} icon="⚖️" decimals={0} />
    </div>
  );
};
export default TreasuryStats;